import { useCallback, useEffect, useState } from "react";
import { del, get, post, put } from "../api";

export default function useUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setUsers(await get("/api/users"));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const createUser = useCallback(
    async (payload) => {
      await post("/api/users", payload);
      await load();
    },
    [load]
  );

  const updateUser = useCallback(
    async (userId, payload) => {
      await put(`/api/users/${userId}`, payload);
      await load();
    },
    [load]
  );

  const setUserPassword = useCallback(
    (userId, payload) => post(`/api/users/${userId}/password`, payload),
    []
  );

  const deleteUser = useCallback(
    async (userId) => {
      await del(`/api/users/${userId}`);
      await load();
    },
    [load]
  );

  return { users, loading, error, reload: load, createUser, updateUser, setUserPassword, deleteUser };
}
